<template>
	<table-list
		:records="mutatedLogs"
		:fields="fields"
		:hide-record-count="true"
		record-name="Time Log"
	></table-list>
</template>

<script>
import TableList from "../TableList"

export default {

	name: 'UsersClockedInTable',
	components: {
		TableList
	},
	props: [
		"filters",
		"projectId",
		"serviceId",
		"fetchTrigger"
	],
	data() {
		return {
			logs: [],
			formAcknowledgements: [],
			fields: [
				{label: "Employee Name",key:"fullname",type:"link"},
				{label: "Clocked In",key:"timeInLocal"},
				{label: "Elapsed Time",key:"timeElapsed"},
				{label: "Forms Signed Today",key:"numFormsSigned",align:"center"},
				{label: "Location", key: 'location'}
			]
		}
	},
	watch: {
		fetchTrigger() {
			this.fetchUsers()
		},
		filters() {
			this.fetchUsers()
		}
	},
	computed: {
		mutatedLogs() {
			let vm = this

			return this.$store.jobOpenTimelogs.map(log => {

				log.fullname = {}

				log.fullname.link = "/employee/"+log.User.slug+"/profile"
				log.fullname.text = log.User.first_name + " " + log.User.last_name

				let hrsElapsed = vm.moment(vm.$store.timeNow).diff(log.time_in,'minutes')/60

				log.timeElapsed = hrsElapsed.round(1) + " hrs"

				log.timeInLocal = this.formatDateTimeToLocal(log.time_in,'month-day-time')

				let uniqueFormsSigned = new Set()

				vm.formAcknowledgements.forEach(ack => {
					if (ack.user_id == log.user_id)
						uniqueFormsSigned.add(ack.form_id)
				})

				log.numFormsSigned = uniqueFormsSigned.size

				let locationDescription = ""

				let isOnsite = log.time_on_site	!= "0000-00-00 00:00:00"

				if (isOnsite)
					locationDescription = "<strong>Onsite</strong> (last recorded " + vm.formatDateTimeToLocal(log.time_on_site) + ")"
				else {

					let job = this.$store.project
					if (this.serviceId > 0)
						job = this.$store.service

					let distance = this.getDistance(log.lat, log.long, job.lat, job.long)
					distance = distance / 1000
					distance = distance.round(1) + " km"

					locationDescription = "<strong>" + distance + "</strong> from jobsite<br>" + log.reason_not_on_site + "<br> (last recorded " + vm.formatDateTimeToLocal(log.time_in) + ")"
				}

				log.location = locationDescription

				return log
			})
		},
		jobId() {
			if (this.serviceId > 0)
				return this.serviceId
			else if (this.projectId > 0)
				return this.projectId
		},
		jobKey() {
			if (this.serviceId > 0)
				return "service_id"
			else if (this.projectId > 0)
				return "job_id"
		}
	},
	methods: {
		fetchUsers() {
			let vm = this

			let filters = []
			if (vm.filters)
				filters = this.filters

			vm.spinner(true)

			let params = {
				filters: filters,
				include: ["User","Job","Service"]
			}

			let formParams = {
				filters: [
					["CompanyForm."+this.jobKey,this.jobId],
					["completed_at >=",this.moment.utc().format("YYYY-MM-DD 00:00:00")],
				],
				include: [{model:"CompanyForm",fields:["id","slug","description","job_id","service_id"]}]
			}

			let promises = [
				vm.getJSON("OpenTimeLog/get",params),
				vm.getJSON("CompanyFormAcknowledgement/get",formParams)
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.timeNow = responses[0].time

				if (responses[0].success) {
					vm.$store.jobOpenTimelogs = responses[0].data

					vm.$emit("logsFetched",responses[0].data)
				}

				if (responses[1].success)
					vm.formAcknowledgements = responses[1].data

			})

		}
	},
	created() {
		this.fetchUsers()
	}
}
</script>

<style type="text/css" scoped>
	.alert {
		margin-bottom: 5px;
	}

	button {
		position: absolute;
		top: 0px;
		right: 5px;
		padding: 5px;
	}
</style>